import { post } from "@/utils/utils";

const guiderCommission = {
  state: {
    supplierBasucList: {},
    redpackageOutletRelList: {},
    storeBasicInfoListBox: {},
    notRelShopList: {},
    hemiaoBrandList: {},
    supplierGoodsInfoList: {},
    hemiaoBrandBoxList: {},
    supplierRewardRuleInfoList: {},
    departBindingStoreBox: [],
    detailsSupplierBasicInfo: {
      ruleInfo: {
        rewardName: "",
      },
    },
    companyCapitalFlowlist: {},
    storeBasicInfoTree: {},
    companyRechargelist: {},
    allCompanyCapitalFlowlist: {},
    commissionReportList: {},
    shopReportList: {},
    guiderReportList: {},
    allCommissionReportList: {},
    marketingDynamic: {},
    auditDynamic: {},
    sendRankingList: [],
    redpacket: {},
    goodsReportList: {},
  },
  mutations: {
    QUERY_SUPPLIER_BASIC_LIST(state, data) {
      state.supplierBasucList = data.result;
    },
    SAVE_SUPPLIER_BASIC_INFO(state, data) {
      state.saveSupplierInfo = data.result;
    },
    DETAILS_SUPPLIER_BASIC_INFO(state, data) {
      state.detailsSupplierInfo = data.result;
    },
    EDIT_SUPPLIER_BASIC_INFO(state, data) {
      state.editSupplierBasicInfo = data.result;
    },
    QUERY_REDPACKAGE_OUT_LIST(state, data) {
      state.redpackageOutletRelList = data.result;
    },
    QUERY_STORE_BASIC_INFO_LIST_BOX(state, data) {
      if (data.result) {
        state.storeBasicInfoListBox = data.result;
      }
    },
    DEL_REDPACKAGE_OUT_REL(state, data) {
      state.delRedpackageOutletRel = data.result;
    },
    QUERY_NOT_REL_SHOP_LIST(state, data) {
      state.notRelShopList = data.result;
    },
    QUERY_FINDREL_SHOP_LIST(state, data) {
      state.notRelShopList = data.result;
    },
    SAVE_REDPACKAGE_OUT_REL(state, data) {
      state.saveRedpackageOutleRel = data.result;
    },
    queryNotRelShop(state) {
      state.notRelShopList = {};
    },
    QUERY_HEMIAO_BRAND_LIST(state, data) {
      state.hemiaoBrandList = data.result;
    },
    DETAILS_HEMIAO_BRAND_LIST(state, data) {
      state.detailsHemiaoBrandList = data.result;
    },
    SAVE_HEMIAO_BRAND_LIST(state, data) {
      state.saveHemiaoBrandList = data.result;
    },
    EDIT_HEMIAO_BRAND_LIST(state, data) {
      state.editHemiaoBrandList = data.result;
    },
    QUERY_SUPPLIER_GOODS_INFO_LIST(state, data) {
      state.supplierGoodsInfoList = data.result;
    },
    QUERY_HEMIAO_BRAND_BOX(state, data) {
      state.hemiaoBrandBoxList = data.result;
    },
    QUERY_ALL_HEMIAO_BRAND_BOX() {},
    SAVE_SUPPLIER_GOODS_INFO_LIST(state, data) {
      state.saveSupplierGoodsInfoList = data.result;
    },
    DEL_SUPPLIER_GOODS_INFO(state, data) {
      state.delSupplierGoodsInfoList = data.result;
    },
    QUERY_SUPPLIER_REWARD_RULE_INFO_LIST(state, data) {
      state.supplierRewardRuleInfoList = data.result;
    },
    QUERY_ACTIVITY_QUERY_PAGE_LIST() {},
    QUERY_DEPART_BINDING_STORE_BOX(state, data) {
      state.departBindingStoreBox = data.result;
    },
    SAVE_SUPPLIER_REWARD_RULE_INFO_LIST(state, data) {
      state.saveSupplierBasicInfo = data.result;
    },
    DETAILS_SUPPLIER_REWARD_RULE_INFO_LIST(state, data) {
      state.detailsSupplierBasicInfo = data.result;
    },
    DEL_SUPPLIER_REWARD_RULE_INFO_LIST(state, data) {
      state.delSupplierBasicInfo = data.result;
    },
    QUERY_COMPANY_CAPITAL_LIST(state, data) {
      state.companyCapitalFlowlist = data.result;
    },
    QUERY_ALL_COMPANY_CAPITAL_LIST(state, data) {
      state.allCompanyCapitalFlowlist = data.result;
    },
    QUERY_STORE_BASIC_TREE(state, data) {
      state.storeBasicInfoTree = data.result;
      // state.storeBasicInfoTree.forEach(v => {
      //   v.leaf = Boolean(v.shopCount > 0 ? false : true);
      // });
    },
    QUERY_STORE_SHOP_TREE(state, data) {
      state.storeShopInfoTree = data.result;
      // state.storeShopInfoTree.forEach(v => {
      //   v.leaf = false;
      // });
    },
    QUERY_RED_PACKET_LIST() {},
    QUERY_ALL_RED_PACKET_LIST() {},
    QUERY_SHARE_ORDER_LIST() {},
    QUERY_ALL_SHARE_ORDER_LIST() {},
    VIEW_SHARE_ORDER_DETAILS() {},
    VIEW_GUIDER_ORDER_DETAILS() {},
    QUERY_RED_PACKET_ROLE_INFO() {},
    QUERY_WIDTHDRAW_LIST() {},
    QUERY_ALL_WIDTHDRAW_LIST() {},
    QUERY_GUIDER_ORDER_LIST() {},
    QUERY_ALL_GUIDER_ORDER_LIST() {},
    EXPORT_REDPACKAGE_OUT_LIST() {},
    QUERY_COMPANY_RECHARGE_LIST(state, data) {
      state.companyRechargelist = data.result;
    },
    QUERY_ALL_COMPANY_RECHARGE_LIST(state, data) {
      state.allCompanyRechargelist = data.result;
    },
    SAVE_RECHARE_ORDER(state, data) {
      state.saveRechargeOrder = data.result;
    },
    AUDIT_RECHARE_ORDER(state, data) {
      state.auditRechargeOrder = data.result;
    },

    QUERY_GOODS_REPORT_LIST(state, data) {
      state.goodsReportList = data.result;
    },
    QUERY_ALL_GOODS_REPORT_LIST() {},
    QUERY_COMMISSION_REPORT_LIST(state, data) {
      state.commissionReportList = data.result;
    },
    OBTAIN_DECLARE_BILL_DETAILS(state, data) {
      state.commissionReportList = data.result;
    },
    NEW_OBTAIN_DECLARE_BILL_DETAILS(state, data) {
      state.commissionReportList = data.result;
    },
    // QUERY_ALL_COMMISSION_REPORT_LIST(state, data) {
    //   state.allCommissionReportList = data.result;
    //   state.allCommissionReportList.records.forEach(v => {
    //     v.citys = v.provinceName + v.cityName + v.districtName;
    //   });
    // },
    QUERY_SHOP_REPORT_LIST(state, data) {
      state.shopReportList = data.result;
    },
    QUERY_ALL_SHOP_REPORT_LIST(state, data) {
      state.allShopReportList = data.result;
      state.allShopReportList.records.forEach((v) => {
        v.citys = v.provinceName + v.cityName + v.districtName;
      });
    },
    QUERY_GUIDER_REPORT_LIST(state, data) {
      state.guiderReportList = data.result;
    },
    QUERY_ALL_GUIDER_REPORT_LIST(state, data) {
      state.allGuiderReportList = data.result;
      state.allGuiderReportList.records.forEach((v) => {
        v.citys = v.provinceName + v.cityName + v.districtName;
      });
    },
    QUERY_MARKETING_DYNAMIC(state, data) {
      state.marketingDynamic = data.result;
    },
    QUERY_AUDIT_DYNAMIC(state, data) {
      state.auditDynamic = data.result;
    },
    QUERY_SEND_RANKING(state, data) {
      state.sendRankingList = data.result;
    },
    QUERY_RED_PACKET_TENDENCY(state, data) {
      state.redpacket = data.result;
    },
    EDIT_RULE_STATE(state, data) {
      state.editRuleState = data.result;
    },
    QUERY_SHOP_DEPART_LIST() {},
    QUERY_SHARE_ORDER_LIST_NEW() {},
    QUERY_ALL_SHARE_ORDER_LIST_NEW() {},
    DETAILS_WITHDRAWAL_RULES() {},
    EDIT_WITHDRAWAL_RULES() {},
    DETAILS_SUPPLIER_GOODS() {},
    EDIT_SUPPLIER_GOODS() {},
    COPY_SUPPLIER_REWARD_RULE_INFO_LIST() {},
    AUDIT_SUPPLIER_REWARD_RULE_INFO() {},
    QUERY_PUB_CAPITAL_FLOW_LIST() {},
    QUERY_ALL_PUB_CAPITAL_FLOW_LIST() {},
    SUBJECT_TYPE() {},
    QUERY_DAY_SUBJECK_CAPITAL_LIST() {},
    QUERY_ALL_DAY_SUBJECK_CAPITAL_LIST() {},
    EXPORT_HM_DETAILS() {},
    ONLINE_OR_OFFLINE() {},
    DETAILS_STORE_OFFLINE_DRAW() {},
    EDIT_STORE_OFFLINE_DRAW() {},
    DRAW_DETAILS_LIST() {},
    DRAW_ALL_DETAILS_LIST() {},
    QUERY_DRAW_GEAR_LIST() {},
    EXPORT_STORE_DETAILS() {},
    EXPORT_GUIDER_DETAILS() {},
    EXPORT_GOODS_SUPPLIER() {},
    BATCH_EDIT_GOODS_SN(){},
    BATCH_EDIT_GOODS_NAME_SUPPLIER() {},
    EXPORT_REWARD_GOODS_SUPPLIER() {},
    IMPORT_REDPACKAGE() {},
    IMPORT_REDPACKAGE_STORE_SHOP_TYPE() {},
    IMPORT_SHOP_TYPE_GUIDER() {},
    EXCHANGE_RECORD_LIST() {},
    EXCHANGE_ALL_RECORD_LIST() {},
    COIN_QUERY_MSG() {},
    CASH_OUT_UPDATE() {},
    QUERY_REWARD_TOTAL_PROFIT() {},
    STORE_OPERATION_LOG_LIST() {},
    GET_GOODS_KEY_WORD() {},
    EDIT_REWARD_RULE_END_DATE() {},
    EXPORT_DECLARE_LIST() {},
    EXPORT_GUIDER_DECLARE_LIST() {},
    EXPORT_GUIDER_BRAND_DECLARE_LIST() {},
    EXPORT_CASH_OUT_LIST() {},
    EDIT_REWARD_INFO() {},
    IMPORT_REDPACKAGE_STORE_LIST() {},
    QUERY_COMMISSION_REPORT_LIST_BY_REWARD() {},
    QUERY_ALL_COMMISSION_REPORT_LIST_BY_REWARD() {},
    QUERY_ALL_HEMIAO_BRAND_BOX_BY_STORE() {},
    QUERY_STORE_RELATION_SUPPLIER() {},
    SYS_RECEIPT_OCR_TEMP_ADD() {},
    SYS_RECEIPT_OCR_TEMP_LIST() {},
    SYS_RECEIPT_OCR_TEMP_DEL() {},
    SYS_RECEIPT_OCR_TEMP_DETAILS() {},
    SYS_RECEIPT_OCR_TEMP_EDIT() {},
    SYS_RECEIPT_OCR_TEMP_ADD_BATCH() {},
    MANAGER_IMPORT_DECLARE() {},
    MANAGER_IMPORT_DECLARE_FLOW() {},
    SYNC_GOODS_IMG() {},
    TENANT_BASIC_INFO_LIST() {},
    RED_OCR_TEMPLATE_PREVIEW() {},
    ADD_REDPACKAGE_SPREAD_ACT() {},
    REDPACKAGE_SPREAD_ACT_LIST() {},
    REDPACKAGE_SPREAD_ACT_ALL_LIST() {},
    DETAILS_REDPACKAGE_SPREAD_ACT() {},
    EDIT_REDPACKAGE_SPREAD_ACT() {},
    QUERY_REDPACKAGE_SPREAD_ACT_LOG() {},
    UPDATE_REDPACKAGE_SPREAD_ACT_STATE() {},
    REDPACKAGE_SPREAD_ACT_SED_MAIL() {},
    QUERY_ALL_REDPACKAGE_SPREAD_ACT_LOG() {},
    QUERY_SPREAD_MEMBER() {},
    UPDATE_INVALID() {},
    QUERY_SPREAD_MEMBER_STATISTIC_LIST() {},
    BATCH_SAVE_HEMIAO_BRAND_INFO() {},
    BATCH_SAVE_AGENCY() {},
    REDPACKAGE_GOODS_REPORT_LIST() {},
    REDPACKAGE_COMMISSION_REPORT_LIST() {},
    EXPORT_DECLARE_BILL_DETAILS() {},
    NEW_EXPORT_DECLARE_BILL_DETAILS() {},
    REDPACKAGE_SHOP_REPORT_LIST() {},
    REDPACKAGE_GUIDER_REPORT_LIST() {},
    REDPACKAGE_COMMISSION_REPORT_LIST_BY_REWARD() {},
    COMPANY_RECHARGE_LIST() {},
    COMPANY_CAPITAL_FLOW_LIST() {},
    GUIDER_RECHARGE_LIST() {},
    QUERY_PAGE_SERIES_LIST() {},
    ADD_PAGE_SERIES_LIST() {},
    DELETE_PAGE_SERIES_LIST() {},
    SUPPLIER_AGENCY_REL_LIST() {},
    QUERY_SUPPLIER_AGENCY_REL_BRAND_LIST() {},
    QUERY_SUPPLIER_AGENCY_REL_SERIES_LIST() {},
    ADD_SUPPLIER_AGENCY_REL_SERIES_LIST() {},
    EDIT_SUPPLIER_AGENCY_REL_SERIES_LIST() {},
    RED_PACKAGE_ADD_AGENT() {},
    QUERY_RED_PACKAGE_AGENT_LIST() {},
    QUERY_AGENT_SETTLEMENT_LIST() {},
    QUERY_SERVICE_PROVIDER_EXPAND_INFO_MODEL() {},
    IMPORT_NOT_REL_SHOP() {},
    QUERY_AGENT_SETTLEMENT_DETAIL() {},
    PRE_IMPORT_STORE() {},
    RED_PACKAGE_CAT_SHOPS() {},
    RED_PACKAGE_GET_LIKE_STORE() {},
    RED_PACKAGE_SAVE_BATCH_STORE_LIST() {},
    SUPPLIER_GOODS_INFO_CHECK_GOODS() {},
    SUPPLIER_MESSAGE_INFO_ADD() {},
    SUPPLIER_MESSAGE_INFO_LIST() {},
    SUPPLIER_MESSAGE_INFO_DEL() {},
    SUPPLIER_MESSAGE_INFO_DETAILS() {},
    SUPPLIER_MESSAGE_INFO_EDIT() {},
    SETTLE_AUDIT() {},
    QUERY_SETTLE_LOGLIST() {},
    QUERY_SETTLE_AGENT_LIST() {},
    QUERY_TI_XIAN_LIST() {},
    AGENT_TI_XIAN_AUDIT() {},
    QUERY_REDPACKAGE_SUPPLIER_PERCENTAGE_RULE() {},
    QUERY_STORE_SHARE_CONFIG_LIST() {},
    QUERY_STORE_SHARE_GUIDER_LIST() {},
    SUBMIT_STORE_SHARE_CONFIG() {},
    EDIT_STORE_SHARE_CONFIG() {},
    DEL_STORE_SHARE_CONFIG() {},
    QUERY_SUPPLIER_GUIDER_PAGE_LIST() {},
    SUBMIT_STORE_SHARE_GUIDER() {},
    EDIT_STORE_SHARE_GUIDER_ACCOUNT_STATE() {},
    DEL_STORE_SHARE_GUIDER() {},
    IMPORT_STORE_SHARE_GUIDER() {},
    QUERY_STORE_SHARE_MANAGE_LIST() {},
    REDPACKAGE_STORE_SHARE_LIST_OUTPUT() {},
    QUERY_GUIDER_FLOW_LIST() {},
    SAVE_MONTHLY_STATEMENT_SHOP() {},
    IMPORT_MONTHLY_STATEMENT_GUIDER() {},
    MOBILE_BY_STORE_NAME_LIST() {},
    EDIT_AGENCY_FUNC_AUTH() {},
    IMPORT_AGENCY() {},
    IMPORT_AGENCY_REL_SHOP() {},
    BATCH_EDIT_GOODS_SERIES_SUPPLIER() {},
    IMPORT_AGENCY_EMPLOYEE_INFO() {},
    QUERY_LOOK_AUTH() {},
    EDIT_LOOK_AUTH() {},
    QUERY_OCR_MATCH_LOG_LIST() {},
    DELETE_OCR_MATCH_LOG() {},
    EDIT_OCR_MATCH_LOG() {},
    NOTICE_QUERY_LIST() {},
    QUERY_HISTORY_SHARE_RATIO_LOG() {},
    EDIT_REWARD_RULE_END_DATE_BATCH() {},
    PRE_INSPECTION_REDPACKAGE_SPREAD_ACTIVITY() {},
    STORE_ACTIVITY_LIST() {},
    EXPORT_STORE_ACTIVE() {},
    GETCASH_QUERY_PAGE_LIST() {},
    GETCASH_GET() {},
    GETCASH_SAVE() {},
    GETCASH_UPDATE() {},
    GETCASH_QUERY_FLOWER_LIST() {},
    GETCASH_RULE_QUERY_PAGE_LIST() {},
    GETCASH_RULE_GET() {},
    GETCASH_RULE_SAVE() {},
    GETCASH_RULE_UPDATE() {},
    THIRD_CONTRACT_COMPANY_INFO_QUERY_PAGE_LIST() {},
    THIRD_CONTRACT_COMPANY_INFO_ADD() {},
    THIRD_CONTRACT_COMPANY_INFO_EDIT() {},
    THIRD_CONTRACT_CUSTOMER_INFO_QUERY_PAGE_LIST() {},
    THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_UPLOAD_WORK_PLAN() {},
    THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_ZLB_PUBLISH_OLD_TASK() {},
    THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_GZLLE_PUBLISH_OLD_TASK() {},
    THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_QUERY_WORK_PLAN() {},
    QUERY_LAST_GUIDER_WHITE_LIST() {},
    BATCH_FIND_STORE_BASIC_INFO_LIST() {},
    THIRD_COMPANY_INFO_QUERY_PAGE_LIST() {},
    WECHAT_BATCH_STATUS() {},
    BATCH_IMPORT_EMPLOYEE() {},
    ADD_NEW_IDCARD_IMG_BY_CUSTOMER_ID() {},
    DO_CHECK_CUSTOMER_IDENTITY_ELEMENTS() {},
    QUERY_SETTLEMENT_RECORD() {},
    GEN_SETTLEMENT_RECORD() {},
    CHECK_SET_IP_WHITE_LIST_SMS_UNIQUE_CODE() {},
    SEND_SET_IP_WHITE_LIST_SMS_UNIQUE_CODE() {},
    OPERATE_LOCK_GETCASH_SN() {},
    QUERY_CUSTOMER_INFO() {},
    QUERY_CUSTOMER_ARCHIVE_INFO_LIST() {},
    QUERY_CUSTOMER_ARCHIVE_INFO_BY_DYNAMICS_CONDITION() {},
    QUERY_COLLECT_QUERY_LIST() {},
    QUERY_SETTLEMENT_COMPANY_LIST() {},
    QUERY_CUSTOMER_BANK_LIST() {},
    QUERY_NUM_INFO() {},
    BATCH_INCREASE_AUTO_OFFLINE_DAYS_LIMT() {},
    CANCEL_ORDER() {},
    clearCommissionReportList(state) {
      state.commissionReportList = {};
      state.shopReportList = {};
      state.guiderReportList = {};
    },
    // 2024-6-3新增
    SUPPLIER_WORK_CONFIG_QUERY_PAGE_LIST() {},
    SUPPLIER_WORK_CONFIG_REFRESH_WORK_CONFIG() {},
    MANAGER_EXPORT_GUIDER_DECLARE_OPERATE_LIST() {},
    WORK_SUPPLIER_WORK_CONFIG_REMOVE_BYMODEL() {},
    STORE_BASIC_INFO_FIND_AUTH_SUPPLIE_RBASICLIST() {},
    // 2024-6-5
    SUPPLIER_WORK_CONFIG_REFRESH_WORK_CONFIG_BY_SUPPLIER() {},
    STORE_SUBSCRIBEAPPLY_QUERY_SUBSCRIBE_APPLYLIST() {},
    STORE_SSRBASIC_CONFIG_EXPORT_CUSTOM_REPORT() {},
    // 2024-6-11
    SUPPLIER_GOODS_DETAILS_REPORT_OBTAIN_DECLARE_GOODS_DETAILS_ES() {},
    // 2024-6-12
    EXPORT_DECLARE_GOODS_DETAILS_ES() {},
    // 2024-6-14
    OBTAIN_DECLARE_GOODS_ES() {},
    // 2024-6-15
    QUERY_SSR_BASIC_CONFIG() {},
    OBTAIN_DECLARE_BILL_ES() {},
    OBTAIN_SHOP_ES() {},
    OBTAIN_GUIDER_ES() {},
    OBTAIN_BRAND_ES() {},
    OBTAIN_BRAND_DETAILS_ES() {},
    OBTAIN_SHARE_ES() {},
    OBTAIN_REFUND_ES() {},
    // 商户报表查询自定义
    OBTAIN_STORE_DECLARE_GOODS_ES() {},
    OBTAIN_STORE_DECLARE_BILL_ES() {},
    OBTAIN_STORE_SHOP_ES() {},
    OBTAIN_STORE_GUIDER_ES() {},
    OBTAIN_STORE_BRAND_ES() {},
    OBTAIN_STORE_SHARE_ES() {},
    OBTAIN_STORE_REFUND_ES() {},
    OBTAIN_GOODS_REFUND_ES() {},

    EXPORT_DECLARE_GOODS_ES() {},
    EXPORT_DECLARE_BILL_ES() {},
    EXPORT_SHOP_ES() {},
    EXPORT_SHARE_ES() {},
    EXPORT_GUIDER_ES() {},
    EXPORT_BRAND_ES() {},
    EXPORT_BRAND_DETAILS_ES() {},
    EXPORT_REFUND_ES() {},
    EXPORT_GOODS_REFUND_ES() {},
    // 商户自定义导出
    EXPORT_STORE_DECLARE_GOODS_ES() {},
    EXPORT_STORE_DECLARE_BILL_ES() {},
    EXPORT_STORE_SHOP_ES() {},
    EXPORT_STORE_SHARE_ES() {},
    EXPORT_STORE_GUIDER_ES() {},
    EXPORT_STORE_BRAND_ES() {},
    EXPORT_STORE_REFUND_ES() {},
    EXPORT_COMPOSITE_ES() {},
    QUERY_PAGE_LIST() {},
    GET_LIST_BY_CONFIG_CLASS() {},
    ADD_OR_UPDATE_REDPACKAGE_REJECT_REASON() {},
    DEL_REDPACKAGE_REJECT_REASON() {},
    SAVE_REDPACKAGE_BADGE_INFO() {},
    QUERY_REDPACKAGE_BADGE_INFO_PAGE() {},
    QUERY_REDPACKAGE_BADGE_INFO_BY_ID() {},
    EDIT_REDPACKAGE_BADGE_INFO() {},
    EDIT_REDPACKAGE_BADGE_INFO_PUBLISH_STATE() {},
    QUERY_BENEFIT_USE_RECORD_PAGE() {},
    QUERY_BENEFIT_USE_RECORD_GROUP() {},
    EXPORT_GUIDER_BENEFIT_USE_RECORD() {},
    REDPACKAGE_BADGE_SEND_ONLINE_MAIL_MEDAL() {},
    UPDATE_REDPACKAGE_BADGE_INFO_PUBLISH_STATE_MEDAL() {},
    SUPPLIER_GOODS_INFO_CHECK_GOODS_NEW() {},
    GOODS_EXPORT_DATA_LIST() {},
    QUERY_DEPART_LIST() {},
    REWARD_GOODS_IMPORTES() {},
    QUERY_REWARD_GOODS_ESPAGELIST(){},
    SAVE_SUPPLIER_REWARD_RULEIN_FOIMPORT_GOODSES(){},
    VERIFY_REWARF_RULENAME(){},
    SUPPLIER_SET_CONFIG(){},
    GUIDER_VIEW_WUPPLIER_BRAND(){},
    HEMIAO_SET_GUIDER_CONFIG(){},
    GET_GOODS_KEY_WORD_LIST(){},
    EXPORT_ALLOW_AUTO_BRAND_LIST(){}
  },
  actions: {
    queryDepartList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/storeDepartInfo/treeData`,
        name: "QUERY_DEPART_LIST",
        params,
      });
    },
    goods_export_data_list({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/redpackage/manager/goods_export_data_list`,
        name: "GOODS_EXPORT_DATA_LIST",
        params,
      });
    },
    viewGuiderOrderDetails({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/guiderOrderDetails`,
        name: "VIEW_GUIDER_ORDER_DETAILS",
        params,
      });
    },
    queryAllGuiderOrderList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/guiderOrderList`,
        name: "QUERY_ALL_GUIDER_ORDER_LIST",
        params,
      });
    },
    queryGuiderOrderList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/guiderOrderList`,
        name: "QUERY_GUIDER_ORDER_LIST",
        params,
      });
    },

    queryWithDrawOrderList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/getcashList`,
        name: "QUERY_WIDTHDRAW_LIST",
        params,
      });
    },
    queryAllWithDrawOrderList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/getcashList`,
        name: "QUERY_ALL_WIDTHDRAW_LIST",
        params,
      });
    },
    queryAllShareOrderList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/shareOrderList`,
        name: "QUERY_ALL_SHARE_ORDER_LIST",
        params,
      });
    },
    queryShareOrderDetails({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/queryShareOrderDetails`,
        name: "VIEW_SHARE_ORDER_DETAILS",
        params,
      });
    },
    queryRedPacketRoleInfo({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/customerInfo`,
        name: "QUERY_RED_PACKET_ROLE_INFO",
        params,
      });
    },
    queryShareOrderList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/shareOrderList`,
        name: "QUERY_SHARE_ORDER_LIST",
        params,
      });
    },
    queryShareOrderListNew({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/queryCommissionFlowListNew`,
        name: "QUERY_SHARE_ORDER_LIST_NEW",
        params,
      });
    },
    queryAllShareOrderListNew({ commit }, params) {
      return post({
        commit,
        url: `/share/shareSkuDateRangeFlowNew/queryCommissionFlowListNew`,
        name: "QUERY_ALL_SHARE_ORDER_LIST_NEW",
        params,
      });
    },
    queryRedPacketList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/redStatistics`,
        name: "QUERY_RED_PACKET_LIST",
        params,
      });
    },
    queryAllRedPacketList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/redStatistics`,
        name: "QUERY_ALL_RED_PACKET_LIST",
        params,
      });
    },
    querySupplierBasicList({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findSupplierBasicList`,
        name: "QUERY_SUPPLIER_BASIC_LIST",
        params,
      });
    },
    saveSupplierBasicInfo({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/saveSupplierBasicInfo`,
        name: "SAVE_SUPPLIER_BASIC_INFO",
        params,
      });
    },
    detailsSupplierBasicInfo({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findSupplierBasicInfoByStoreCode`,
        name: "DETAILS_SUPPLIER_BASIC_INFO",
        params,
      });
    },
    editSupplierBasicInfo({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/editSupplierBasicInfo`,
        name: "EDIT_SUPPLIER_BASIC_INFO",
        params,
      });
    },
    queryRedpackageOutletRelList({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/findRedpackageOutletRelList`,
        name: "QUERY_REDPACKAGE_OUT_LIST",
        params,
      });
    },
    exportRedpackageOutletRelList({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/exportRedpackageOutletRelList`,
        name: "EXPORT_REDPACKAGE_OUT_LIST",
        params,
      });
    },

    queryFindRelShopList({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/findRelShopList`,
        name: "QUERY_FINDREL_SHOP_LIST",
        params,
      });
    },
    queryStoreBasicInfoListBox({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findDepartBindingStoreComboBox_new`,
        name: "QUERY_STORE_BASIC_INFO_LIST_BOX",
        params,
      });
    },
    delRedpackageOutletRel({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/delRedpackageOutletRel`,
        name: "DEL_REDPACKAGE_OUT_REL",
        params,
      });
    },
    queryNotRelShopList({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/findNotRelShopList`,
        name: "QUERY_NOT_REL_SHOP_LIST",
        params,
      });
    },

    saveRedpackageOutletRel({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/saveRedpackageOutletRel`,
        name: "SAVE_REDPACKAGE_OUT_REL",
        params,
      });
    },
    queryHemiaoBrandList({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/findHemiaoBrandList`,
        name: "QUERY_HEMIAO_BRAND_LIST",
        params,
      });
    },
    detailsHemiaoBrandList({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/findHemiaoBrandById`,
        name: "DETAILS_HEMIAO_BRAND_LIST",
        params,
      });
    },
    saveHemiaoBrandList({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/saveHemiaoBrandinfo`,
        name: "SAVE_HEMIAO_BRAND_LIST",
        params,
      });
    },
    editHemiaoBrandList({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/editHemiaoBrandById`,
        name: "EDIT_HEMIAO_BRAND_LIST",
        params,
      });
    },
    querySupplierGoodsInfoList({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/findSupplierGoodsInfoList`,
        name: "QUERY_SUPPLIER_GOODS_INFO_LIST",
        params,
      });
    },
    queryHemiaoBrandComboBox({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/findHemiaoBrandComboBox`,
        name: "QUERY_HEMIAO_BRAND_BOX",
        params,
      });
    },
    queryAllHemiaoBrandComboBox({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/findHemiaoBrandComboBox`,
        name: "QUERY_ALL_HEMIAO_BRAND_BOX",
        params,
      });
    },
    queryAllHemiaoBrandComboBoxByStore({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/findHemiaoBrandComboBoxByStore`,
        name: "QUERY_ALL_HEMIAO_BRAND_BOX_BY_STORE",
        params,
      });
    },
    saveSupplierGoodsInfoList({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/saveSupplierGoodsInfo`,
        name: "SAVE_SUPPLIER_GOODS_INFO_LIST",
        params,
      });
    },
    delSupplierGoodsInfo({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/delSupplierGoodsInfo`,
        name: "DEL_SUPPLIER_GOODS_INFO",
        params,
      });
    },
    querySupplierRewardRuleInfoList({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/findSupplierRewardRuleInfoList`,
        name: "QUERY_SUPPLIER_REWARD_RULE_INFO_LIST",
        params,
      });
    },
    queryActivityQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/queryPageList`,
        name: "QUERY_ACTIVITY_QUERY_PAGE_LIST",
        params,
      });
    },

    queryDepartBindingStoreComboBox({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findDepartBindingStoreComboBox`,
        name: "QUERY_DEPART_BINDING_STORE_BOX",
        params,
      });
    },
    queryDepartBindingStoreComboBoxNew({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findDepartBindingStoreComboBox_new`,
        name: "QUERY_DEPART_BINDING_STORE_BOX",
        params,
      });
    },
    saveSupplierRewardRuleInfoList({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/saveSupplierRewardRuleInfo`,
        name: "SAVE_SUPPLIER_REWARD_RULE_INFO_LIST",
        params,
      });
    },
    saveSupplierRewardRuleInfoCollocation({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/saveSupplierRewardRuleInfoCollocation`,
        name: "SAVE_SUPPLIER_REWARD_RULE_INFO_LIST",
        params,
      });
    },
    updateSupplierRewardRuleInfoCollocation({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/updateSupplierRewardRuleInfoCollocation`,
        name: "SAVE_SUPPLIER_REWARD_RULE_INFO_LIST",
        params,
      });
    },
    detailsSupplierRewardRuleInfoList({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/findSupplierRewardRuleInfoById`,
        name: "DETAILS_SUPPLIER_REWARD_RULE_INFO_LIST",
        params,
      });
    },
    queryRewardTotalProfit({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/query_reward_total_profit`,
        name: "QUERY_REWARD_TOTAL_PROFIT",
        params,
      });
    },
    copySupplierRewardRuleInfo({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/copy`,
        name: "COPY_SUPPLIER_REWARD_RULE_INFO_LIST",
        params,
      });
    },
    auditSupplierRewardRuleInfo({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/auditSupplierRewardRuleInfo`,
        name: "AUDIT_SUPPLIER_REWARD_RULE_INFO",
        params,
      });
    },
    findSupplierRewardRuleInfoCollocationList({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/findSupplierRewardRuleInfoCollocationList`,
        name: "COPY_SUPPLIER_REWARD_RULE_INFO_LIST",
        params,
      });
    },
    delSupplierRewardRuleInfoList({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/delSupplierRewardRuleInfo`,
        name: "DEL_SUPPLIER_REWARD_RULE_INFO_LIST",
        params,
      });
    },
    queryCompanyCapitalFlowlist({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findCompanyCapitalFlowlist`,
        name: "QUERY_COMPANY_CAPITAL_LIST",
        params,
      });
    },
    queryAllCompanyCapitalFlowlist({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findCompanyCapitalFlowlist`,
        name: "QUERY_ALL_COMPANY_CAPITAL_LIST",
        params,
      });
    },
    // queryStoreBasicInfoTree({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/storeBasicInfo/findDepartBindingStoreComboBox`,
    //     name: "QUERY_STORE_BASIC_TREE",
    //     params
    //   });
    // },
    queryStoreBasicInfoTree({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findDepartBindingStoreComboBox_new`,
        name: "QUERY_STORE_BASIC_TREE",
        params,
      });
    },
    queryStoreShopInfoTree({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findStoreShopInfoComboBox`,
        name: "QUERY_STORE_SHOP_TREE",
        params,
      });
    },
    queryCompanyRechargelist({ commit }, params) {
      return post({
        commit,
        url: `/companyRechargeOrder/findCompanyRechargelist`,
        name: "QUERY_COMPANY_RECHARGE_LIST",
        params,
      });
    },
    queryAllCompanyRechargelist({ commit }, params) {
      return post({
        commit,
        url: `/companyRechargeOrder/findCompanyRechargelist`,
        name: "QUERY_ALL_COMPANY_RECHARGE_LIST",
        params,
      });
    },
    saveRechargeOrder({ commit }, params) {
      return post({
        commit,
        url: `/companyRechargeOrder/saveCompanyRechargeOrder`,
        name: "SAVE_RECHARE_ORDER",
        params,
      });
    },
    auditRechargeOrder({ commit }, params) {
      return post({
        commit,
        url: `/companyRechargeOrder/auditRechargeOrderState`,
        name: "AUDIT_RECHARE_ORDER",
        params,
      });
    },
    queryGoodsReportList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findGoodsReportList`,
        name: "QUERY_GOODS_REPORT_LIST",
        params,
      });
    },
    queryAllGoodsReportList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findGoodsReportList`,
        name: "QUERY_ALL_GOODS_REPORT_LIST",
        params,
      });
    },
    queryCommissionReportList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findCommissionReportList`,
        name: "QUERY_COMMISSION_REPORT_LIST",
        params,
      });
    },
    clearCommissionReportList({ commit }) {
      commit("clearCommissionReportList");
    },
    obtainDeclareBillDetailsEs({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierRewardReport/obtainDeclareBillDetailsEs`,
        name: "OBTAIN_DECLARE_BILL_DETAILS",
        params,
      });
    },
    newobtainDeclareBillDetailsEs({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierDeclareBillDetailsReport/obtainDeclareBillDetailsEs`,
        name: "NEW_OBTAIN_DECLARE_BILL_DETAILS",
        params,
      });
    },
    obtainDeclareBillDetailsMysql({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierRewardReport/obtainDeclareBillDetailsMysql`,
        name: "OBTAIN_DECLARE_BILL_DETAILS",
        params,
      });
    },
    // queryAllCommissionReportList1({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/capital/companyCapitalFlow/findCommissionReportList`,
    //     name: "QUERY_ALL_COMMISSION_REPORT_LIST",
    //     params
    //   });
    // },
    queryShopReportList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findShopReportList`,
        name: "QUERY_SHOP_REPORT_LIST",
        params,
      });
    },
    queryAllShopReportList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findShopReportList`,
        name: "QUERY_ALL_SHOP_REPORT_LIST",
        params,
      });
    },
    queryGuiderReportList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findGuiderReportList`,
        name: "QUERY_GUIDER_REPORT_LIST",
        params,
      });
    },
    queryAllGuiderReportList({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findGuiderReportList`,
        name: "QUERY_ALL_GUIDER_REPORT_LIST",
        params,
      });
    },
    queryMarketingDynamic({ commit }, params) {
      return post({
        commit,
        url: `/homePage/findMarketingDynamic`,
        name: "QUERY_MARKETING_DYNAMIC",
        params,
      });
    },
    queryAuditDynamic({ commit }, params) {
      return post({
        commit,
        url: `/homePage/findAuditDynamic`,
        name: "QUERY_AUDIT_DYNAMIC",
        params,
      });
    },
    querySendRanking({ commit }, params) {
      return post({
        commit,
        url: `/homePage/findSendRanking`,
        name: "QUERY_SEND_RANKING",
        params,
      });
    },
    queryRedPacketTendency({ commit }, params) {
      return post({
        commit,
        url: `/homePage/findRedPacketTendency`,
        name: "QUERY_RED_PACKET_TENDENCY",
        params,
      });
    },
    editRuleState({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/editRewardRuleState`,
        name: "EDIT_RULE_STATE",
        params,
      });
    },
    queryShopDepartList({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/findRedpackageShopDepartList`,
        name: "QUERY_SHOP_DEPART_LIST",
        params,
      });
    },
    detailswithdrawalRules({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/config_info`,
        name: "DETAILS_WITHDRAWAL_RULES",
        params,
      });
    },
    editWithdrawalRules({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/config_edit`,
        name: "EDIT_WITHDRAWAL_RULES",
        params,
      });
    },
    detailsSupplierGoods({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/findSupplierGoodsInfoById`,
        name: "DETAILS_SUPPLIER_GOODS",
        params,
      });
    },
    editSupplierGoodsInfoById({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/editSupplierGoodsInfoById`,
        name: "EDIT_SUPPLIER_GOODS",
        params,
      });
    },
    queryPubCapitalFlowList({ commit }, params) {
      return post({
        commit,
        url: `/store/daystatSubjectCapitalSettlement/list`,
        name: "QUERY_PUB_CAPITAL_FLOW_LIST",
        params,
      });
    },
    queryAllPubCapitalFlowList({ commit }, params) {
      return post({
        commit,
        url: `/store/daystatSubjectCapitalSettlement/list`,
        name: "QUERY_ALL_PUB_CAPITAL_FLOW_LIST",
        params,
      });
    },
    subjectAllType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=subject_type`,
        name: "SUBJECT_TYPE",
        params,
      });
    },
    queryDaySubjeckCapitalList({ commit }, params) {
      return post({
        commit,
        url: `/store/daystatSubjectCapitalSummary/list`,
        name: "QUERY_DAY_SUBJECK_CAPITAL_LIST",
        params,
      });
    },
    queryAllDaySubjeckCapitalList({ commit }, params) {
      return post({
        commit,
        url: `/store/daystatSubjectCapitalSummary/list`,
        name: "QUERY_ALL_DAY_SUBJECK_CAPITAL_LIST",
        params,
      });
    },
    exportHemiaoDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/financialReports/exportHemiaoDetails?false`,
        name: "EXPORT_HM_DETAILS",
        params,
      });
    },
    onlineOrOffline({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/onlineOrOffline`,
        name: "ONLINE_OR_OFFLINE",
        params,
      });
    },
    detailsStoreOfflineDraw({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/details`,
        name: "DETAILS_STORE_OFFLINE_DRAW",
        params,
      });
    },
    editStoreOfflineDraw({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/edit`,
        name: "EDIT_STORE_OFFLINE_DRAW",
        params,
      });
    },
    drawDetailsList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/drawRecordListNew`,
        name: "DRAW_DETAILS_LIST",
        params,
      });
    },
    drawAllDetailsList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/drawRecordListNew`,
        name: "DRAW_ALL_DETAILS_LIST",
        params,
      });
    },
    exchangeRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/exchangeRecordList`,
        name: "EXCHANGE_RECORD_LIST",
        params,
      });
    },
    exchangeAllRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/exchangeRecordList`,
        name: "EXCHANGE_ALL_RECORD_LIST",
        params,
      });
    },
    queryDrawGearList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeOfflineDrawRule/queryDrawGearList`,
        name: "QUERY_DRAW_GEAR_LIST",
        params,
      });
    },
    exportStoreDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/financialReports/exportStoreDetails?false`,
        name: "EXPORT_STORE_DETAILS",
        params,
      });
    },
    exportGuiderDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/financialReports/exportGuiderDetails?false`,
        name: "EXPORT_GUIDER_DETAILS",
        params,
      });
    },
    exportGoodsSupplier({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/goods_export`,
        name: "EXPORT_GOODS_SUPPLIER",
        params,
      });
    },
    batchEditGoodsSn({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/batch_edit_goods_sn`,
        name: "BATCH_EDIT_GOODS_SN",
        params,
      });
    },
    batchEditGoodsNameSupplier({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/batch_edit_goods_name`,
        name: "BATCH_EDIT_GOODS_NAME_SUPPLIER",
        params,
      });
    },
    batchEditGoodsPriceSupplier({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/batch_edit_goods_price`,
        name: "BATCH_EDIT_GOODS_PRICE_SUPPLIER",
        params,
      });
    },
    exportRewardGoodsSupplier({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/reward_goods_export`,
        name: "EXPORT_REWARD_GOODS_SUPPLIER",
        params,
      });
    },
    importRedpackageStore({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/importRedpackageStore`,
        name: "IMPORT_REDPACKAGE",
        params,
      });
    },
    importShopTypeGuider({ commit }, params) {
      return post({
        commit,
        url: `/config/supplierShopAttrRelation/importShopTypeGuider`,
        name: "IMPORT_SHOP_TYPE_GUIDER",
        params,
      });
    },
    importRedpackageStoreShopType({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/importRedpackageStoreShopType`,
        name: "IMPORT_REDPACKAGE_STORE_SHOP_TYPE",
        params,
      });
    },
    importRedpackageStoreList({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/saveBatchStoreShopInfoList`,
        name: "IMPORT_REDPACKAGE_STORE_LIST",
        params,
      });
    },
    coinQueryMsg({ commit }, params) {
      return post({
        commit,
        url: `/noauth/redmoney/coin_query_msg`,
        name: "COIN_QUERY_MSG",
        params,
      });
    },
    cashOutUpdate({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/cash_out/update`,
        name: "CASH_OUT_UPDATE",
        params,
      });
    },
    storeOperationLogList({ commit }, params) {
      return post({
        commit,
        url: `/sys/storeOperationLog/list?pageSize=${params.pageSize}&pageNo=${
          params.pageNo
        }&bizDataPk=${params.bizDataPk}&bizType=${params.bizType}`,
        name: "STORE_OPERATION_LOG_LIST",
        params,
      });
    },
    getGoodsKeyWord({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/get_goods_keyWord`,
        name: "GET_GOODS_KEY_WORD",
        params,
      });
    },
    editRewardRuleEndDate({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/editRewardRuleEndDate`,
        name: "EDIT_REWARD_RULE_END_DATE",
        params,
      });
    },
    exoprtDeclareList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/back_declare/list?false`,
        name: "EXPORT_DECLARE_LIST",
        params,
      });
    },
    exoprtGuiderDeclareList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/guider_declare/list?false`,
        name: "EXPORT_GUIDER_DECLARE_LIST",
        params,
      });
    },
    exoprtGuiderBrandDeclareList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/guider_brand_rel/list?false`,
        name: "EXPORT_GUIDER_BRAND_DECLARE_LIST",
        params,
      });
    },
    exoprtCashOutList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/cash_out/list?false`,
        name: "EXPORT_CASH_OUT_LIST",
        params,
      });
    },
    editRewardRuleInfo({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/editRewardRuleInfo`,
        name: "EDIT_REWARD_INFO",
        params,
      });
    },
    findCommissionReportListGroupByReward({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findCommissionReportListGroupByReward`,
        name: "QUERY_COMMISSION_REPORT_LIST_BY_REWARD",
        params,
      });
    },
    findAllCommissionReportListGroupByReward({ commit }, params) {
      return post({
        commit,
        url: `/capital/companyCapitalFlow/findCommissionReportListGroupByReward`,
        name: "QUERY_ALL_COMMISSION_REPORT_LIST_BY_REWARD",
        params,
      });
    },
    findStoreRelationSupplier({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/findStoreRelationSupplier`,
        name: "QUERY_STORE_RELATION_SUPPLIER",
        params,
      });
    },
    sysReceiptOcrTemplateAdd({ commit }, params) {
      return post({
        commit,
        url: `/store/sysReceiptOcrTemplate/add`,
        name: "SYS_RECEIPT_OCR_TEMP_ADD",
        params,
      });
    },
    sysReceiptOcrTemplateList({ commit }, params) {
      return post({
        commit,
        url: `/store/sysReceiptOcrTemplate/queryPageList`,
        name: "SYS_RECEIPT_OCR_TEMP_LIST",
        params,
      });
    },
    sysReceiptOcrTemplateDel({ commit }, params) {
      return post({
        commit,
        url: `/store/sysReceiptOcrTemplate/delete`,
        name: "SYS_RECEIPT_OCR_TEMP_DEL",
        params,
      });
    },
    sysReceiptOcrTemplateDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/sysReceiptOcrTemplate/queryById`,
        name: "SYS_RECEIPT_OCR_TEMP_DETAILS",
        params,
      });
    },
    sysReceiptOcrTemplateEdit({ commit }, params) {
      return post({
        commit,
        url: `/store/sysReceiptOcrTemplate/edit`,
        name: "SYS_RECEIPT_OCR_TEMP_EDIT",
        params,
      });
    },
    sysReceiptOcrTemplateAddBatch({ commit }, params) {
      return post({
        commit,
        url: `/store/sysReceiptOcrTemplate/addBatch`,
        name: "SYS_RECEIPT_OCR_TEMP_ADD_BATCH",
        params,
      });
    },
    managerImportDeclare({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/import/declare`,
        name: "MANAGER_IMPORT_DECLARE",
        params,
      });
    },
    managerImportDeclareFlow({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/import/declareFlow`,
        name: "MANAGER_IMPORT_DECLARE_FLOW",
        params,
      });
    },
    syncGoosImg({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/goods_pic_sync`,
        name: "SYNC_GOODS_IMG",
        params,
      });
    },
    tenantBasicInfoList({ commit }, params) {
      return post({
        commit,
        url: `/system/tenantBasicInfo/queryPageList`,
        name: "TENANT_BASIC_INFO_LIST",
        params,
      });
    },
    redEnvelopeTemplatePreviwe({ commit }, params) {
      return post({
        commit,
        url: `/store/sysReceiptOcrTemplate/preview`,
        name: "RED_OCR_TEMPLATE_PREVIEW",
        params,
      });
    },
    createRedpackageSpreadActivity({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/createRedpackageSpreadActivity`,
        name: "ADD_REDPACKAGE_SPREAD_ACT",
        params,
      });
    },
    redpackageSpreadActivityList({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/redpackageSpreadActivityList`,
        name: "REDPACKAGE_SPREAD_ACT_LIST",
        params,
      });
    },
    redpackageSpreadActivityAllList({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/redpackageSpreadActivityList`,
        name: "REDPACKAGE_SPREAD_ACT_ALL_LIST",
        params,
      });
    },
    detailsRedpackageSpreadActivity({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/catRedpackageSpreadActivity`,
        name: "DETAILS_REDPACKAGE_SPREAD_ACT",
        params,
      });
    },
    editRedpackageSpreadActivity({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/updateRedpackageSpreadActivity`,
        name: "EDIT_REDPACKAGE_SPREAD_ACT",
        params,
      });
    },
    queryRedpackageSpreadActivityLog({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/queryRedpackageSpreadActivityLog`,
        name: "QUERY_REDPACKAGE_SPREAD_ACT_LOG",
        params,
      });
    },
    queryAllRedpackageSpreadActivityLog({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/queryRedpackageSpreadActivityLog`,
        name: "QUERY_ALL_REDPACKAGE_SPREAD_ACT_LOG",
        params,
      });
    },
    updateSpreadAcitivityEnabledState({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/updateSpreadAcitivityEnabledState`,
        name: "UPDATE_REDPACKAGE_SPREAD_ACT_STATE",
        params,
      });
    },
    redpackageSpreadSendOnlineMail({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/redpackageSpreadSendOnlineMail`,
        name: "REDPACKAGE_SPREAD_ACT_SED_MAIL",
        params,
      });
    },
    querySpreadMember({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/querySpreadMember`,
        name: "QUERY_SPREAD_MEMBER",
        params,
      });
    },
    updateInvalid({ commit }, params) {
      return post({
        commit,
        url: `/store/potentialCustomersInfo/updateInvalid`,
        name: "UPDATE_INVALID",
        params,
      });
    },
    redpackageSpreadStatistic({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/redpackageSpreadStatistic`,
        name: "QUERY_SPREAD_MEMBER_STATISTIC_LIST",
        params,
      });
    },
    batchSaveHemiaoBrandinfo({ commit }, params) {
      return post({
        commit,
        url: `/hemiao100BrandInfo/batchSaveHemiaoBrandinfo`,
        name: "BATCH_SAVE_HEMIAO_BRAND_INFO",
        params,
      });
    },
    batchSaveAgency({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/import`,
        name: "BATCH_SAVE_AGENCY",
        params,
      });
    },
    redpackageGoodsReportList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/goodsReportList?false`,
        name: "REDPACKAGE_GOODS_REPORT_LIST",
        params,
      });
    },
    exportDeclareGoodsDetailsEs({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierGoodsDetailsReport/exportDeclareGoodsDetailsEs`,
        name: "EXPORT_DECLARE_GOODS_DETAILS_ES",
        params,
      });
    },
    redpackageCommissionReportList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/commissionReportList?false`,
        name: "REDPACKAGE_COMMISSION_REPORT_LIST",
        params,
      });
    },
    exportDeclareBillDetailsEs({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierRewardReport/exportDeclareBillDetailsEs?false`,
        name: "EXPORT_DECLARE_BILL_DETAILS",
        params,
      });
    },
    newexportDeclareBillDetailsEs({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierDeclareBillDetailsReport/exportDeclareBillDetailsEs`,
        name: "NEW_EXPORT_DECLARE_BILL_DETAILS",
        params,
      });
    },
    redpackageShopReportList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/shopReportList?false`,
        name: "REDPACKAGE_SHOP_REPORT_LIST",
        params,
      });
    },
    redpackageGuiderReportList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/guiderReportList?false`,
        name: "REDPACKAGE_GUIDER_REPORT_LIST",
        params,
      });
    },
    redpackageCommissionReportListGroupByReward({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/commissionReportListGroupByReward?false`,
        name: "REDPACKAGE_COMMISSION_REPORT_LIST_BY_REWARD",
        params,
      });
    },
    companyRechargeList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/companyRechargeList?false`,
        name: "COMPANY_RECHARGE_LIST",
        params,
      });
    },
    companyCapitalFlowList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/companyCapitalFlowList?false`,
        name: "COMPANY_CAPITAL_FLOW_LIST",
        params,
      });
    },
    guiderRechargeRecord({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/guider_recharge_record`,
        name: "GUIDER_RECHARGE_LIST",
        params,
      });
    },
    queryPageSeriesList({ commit }, params) {
      return post({
        commit,
        url: `/store/hemiao100BrandSeriesInfo/queryPageList`,
        name: "QUERY_PAGE_SERIES_LIST",
        params,
      });
    },
    addPageSeriesList({ commit }, params) {
      return post({
        commit,
        url: `/store/hemiao100BrandSeriesInfo/add`,
        name: "ADD_PAGE_SERIES_LIST",
        params,
      });
    },
    deletePageSeriesList({ commit }, params) {
      return post({
        commit,
        url: `/store/hemiao100BrandSeriesInfo/delete`,
        name: "DELETE_PAGE_SERIES_LIST",
        params,
      });
    },
    supplierAgencyRelList({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/query_list`,
        name: "SUPPLIER_AGENCY_REL_LIST",
        params,
      });
    },
    querySupplierAgencyRelBrandList({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/query_brand_list`,
        name: "QUERY_SUPPLIER_AGENCY_REL_BRAND_LIST",
        params,
      });
    },
    querySupplierAgencyRelSeriesList({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/query_agency_series`,
        name: "QUERY_SUPPLIER_AGENCY_REL_SERIES_LIST",
        params,
      });
    },
    addSupplierAgencyRelSeriesList({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/add`,
        name: "ADD_SUPPLIER_AGENCY_REL_SERIES_LIST",
        params,
      });
    },
    editSupplierAgencyRelSeriesList({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/edit_agency_series`,
        name: "EDIT_SUPPLIER_AGENCY_REL_SERIES_LIST",
        params,
      });
    },
    redPackageAddAgent({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/add`,
        name: "RED_PACKAGE_ADD_AGENT",
        params,
      });
    },
    queryRedPackageAgentList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/list`,
        name: "QUERY_RED_PACKAGE_AGENT_LIST",
        params,
      });
    },
    queryAgentSettlementList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/settle_list`,
        name: "QUERY_AGENT_SETTLEMENT_LIST",
        params,
      });
    },
    queryServiceProviderExpandInfoModel({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/getServiceProviderExpandInfoModel`,
        name: "QUERY_SERVICE_PROVIDER_EXPAND_INFO_MODEL",
        params,
      });
    },
    importNotRelShop({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/importNotRelShop`,
        name: "IMPORT_NOT_REL_SHOP",
        params,
      });
    },
    queryAgentSettlementDetail({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/settle_detail`,
        name: "QUERY_AGENT_SETTLEMENT_DETAIL",
        params,
      });
    },
    preImportStore({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/pre/importStore`,
        name: "PRE_IMPORT_STORE",
        params,
      });
    },
    redPackageCatShops({ commit }, params) {
      return post({
        commit,
        url:
          `/storeBasicInfo/likeShop?storeCode=` +
          params.storeCode +
          "&storeName=" +
          params.storeName,
        name: "RED_PACKAGE_CAT_SHOPS",
        params,
      });
    },
    redPackAgeGetLikeStore({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/likeStore`,
        name: "RED_PACKAGE_GET_LIKE_STORE",
        params,
      });
    },
    redPackageSaveBatchStoreList({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/importStore`,
        name: "RED_PACKAGE_SAVE_BATCH_STORE_LIST",
        params,
      });
    },
    supplierGoodsInfoCheckGoodsNew({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/check_goods_opt`,
        name: "SUPPLIER_GOODS_INFO_CHECK_GOODS_NEW",
        params,
      });
    },
    supplierGoodsInfoCheckGoods({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/check_goods`,
        name: "SUPPLIER_GOODS_INFO_CHECK_GOODS",
        params,
      });
    },
    supplierWindowMessageInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierWindowMessageInfo/add`,
        name: "SUPPLIER_MESSAGE_INFO_ADD",
        params,
      });
    },
    supplierWindowMessageInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierWindowMessageInfo/list`,
        name: "SUPPLIER_MESSAGE_INFO_LIST",
        params,
      });
    },
    supplierWindowMessageInfoDelete({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierWindowMessageInfo/delete`,
        name: "SUPPLIER_MESSAGE_INFO_DEL",
        params,
      });
    },
    supplierWindowMessageInfoDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierWindowMessageInfo/detail`,
        name: "SUPPLIER_MESSAGE_INFO_DETAILS",
        params,
      });
    },
    supplierWindowMessageInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierWindowMessageInfo/edit`,
        name: "SUPPLIER_MESSAGE_INFO_EDIT",
        params,
      });
    },
    settleAudit({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/settle_audit`,
        name: "SETTLE_AUDIT",
        params,
      });
    },
    querySettleLogList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/settle_oper_list`,
        name: "QUERY_SETTLE_LOGLIST",
        params,
      });
    },
    querySettleAgentList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/list`,
        name: "QUERY_SETTLE_AGENT_LIST",
        params,
      });
    },
    queryTiXianList({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/cash_out/list`,
        name: "QUERY_TI_XIAN_LIST",
        params,
      });
    },
    agentTiXianAudit({ commit }, params) {
      return post({
        commit,
        url: `/store/serviceProviderExpandInfo/cash_out/operate`,
        name: "AGENT_TI_XIAN_AUDIT",
        params,
      });
    },
    queryRedpackageSupplierPercentageRule({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/querySupplierPercentageRule`,
        name: "QUERY_REDPACKAGE_SUPPLIER_PERCENTAGE_RULE",
        params,
      });
    },
    queryStoreShareConfigList({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/configList`,
        name: "QUERY_STORE_SHARE_CONFIG_LIST",
        params,
      });
    },
    queryStoreShareGuiderList({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/guiderAccountList`,
        name: "QUERY_STORE_SHARE_GUIDER_LIST",
        params,
      });
    },
    submitStoreShareConfig({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/configSave`,
        name: "SUBMIT_STORE_SHARE_CONFIG",
        params,
      });
    },
    editStoreShareConfig({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/configEdit`,
        name: "EDIT_STORE_SHARE_CONFIG",
        params,
      });
    },
    delStoreShareConfig({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/configDel`,
        name: "DEL_STORE_SHARE_CONFIG",
        params,
      });
    },
    querySupplierGuiderPageList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider/pageList`,
        name: "QUERY_SUPPLIER_GUIDER_PAGE_LIST",
        params,
      });
    },
    submitStoreShareGuider({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/guiderSave`,
        name: "SUBMIT_STORE_SHARE_GUIDER",
        params,
      });
    },
    editStoreShareGuiderAccountState({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/guiderEdit`,
        name: "EDIT_STORE_SHARE_GUIDER_ACCOUNT_STATE",
        params,
      });
    },
    delStoreShareGuider({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/guiderDel`,
        name: "DEL_STORE_SHARE_GUIDER",
        params,
      });
    },
    importStoreShareGuider({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/guiderImport`,
        name: "IMPORT_STORE_SHARE_GUIDER",
        params,
      });
    },
    queryStoreShareManageList({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/manageList`,
        name: "QUERY_STORE_SHARE_MANAGE_LIST",
        params,
      });
    },
    redpackageStoreShareListOutput({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/storeShareList`,
        name: "REDPACKAGE_STORE_SHARE_LIST_OUTPUT",
        params,
      });
    },
    queryGuiderFlowList({ commit }, params) {
      return post({
        commit,
        url: `/redMoney/customerIdentityInfo/customer_capital_flow_record`,
        name: "QUERY_GUIDER_FLOW_LIST",
        params,
      });
    },
    saveMonthlyStatementShop({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_info/editShopMonthlyStatement`,
        name: "SAVE_MONTHLY_STATEMENT_SHOP",
        params,
      });
    },
    changeGuiderDeclareState({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_info/changeGuiderDeclareState`,
        name: "CHANGE_GUIDER_DECLARE_STATE",
        params,
      });
    },
    importMonthlyStatementGuider({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_info/importShopMonthlyStatementGuider`,
        name: "IMPORT_MONTHLY_STATEMENT_GUIDER",
        params,
      });
    },
    mobileByStoreNameList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/guider_declare/mobileByStoreNameList`,
        name: "MOBILE_BY_STORE_NAME_LIST",
        params,
      });
    },
    editAgencyFuncAuth({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/agencyFuncAuth/editLookData`,
        name: "EDIT_AGENCY_FUNC_AUTH",
        params,
      });
    },
    importAgency({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/importSupplier`,
        name: "IMPORT_AGENCY",
        params,
      });
    },
    importAgencyRelShop({ commit }, params) {
      return post({
        commit,
        url: `/store/supplierAgencyRel/relShopImport`,
        name: "IMPORT_AGENCY_REL_SHOP",
        params,
      });
    },
    batchEditGoodsSeriesSupplier({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/batch_edit_goods_series`,
        name: "BATCH_EDIT_GOODS_SERIES_SUPPLIER",
        params,
      });
    },
    importAgencyEmployeeInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/importEmployee`,
        name: "IMPORT_AGENCY_EMPLOYEE_INFO",
        params,
      });
    },
    queryLookAuth({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/queryGuiderLookStoreShareDataAuth`,
        name: "QUERY_LOOK_AUTH",
        params,
      });
    },
    editLookAuth({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/editGuiderLookStoreShareDataAuth`,
        name: "EDIT_LOOK_AUTH",
        params,
      });
    },
    queryOcrMatchLogList({ commit }, params) {
      return post({
        commit,
        url: `/supplier/ocrMatchLog/pageList`,
        name: "QUERY_OCR_MATCH_LOG_LIST",
        params,
      });
    },
    deleteOcrMatchLog({ commit }, params) {
      return post({
        commit,
        url: `/supplier/ocrMatchLog/deleteMatchLog`,
        name: "DELETE_OCR_MATCH_LOG",
        params,
      });
    },
    editOcrMatchLog({ commit }, params) {
      return post({
        commit,
        url: `/supplier/ocrMatchLog/editMatchLog`,
        name: "EDIT_OCR_MATCH_LOG",
        params,
      });
    },
    noticeQueryList({ commit }, params) {
      return post({
        commit,
        url: `/notice/supplierReceiptDeclareBillNotice/queryList`,
        name: "NOTICE_QUERY_LIST",
        params,
      });
    },
    queryHistoryShareRatioLog({ commit }, params) {
      return post({
        commit,
        url: `/supplier/storeShare/manage/queryHistoryStoreShareRatioLog`,
        name: "QUERY_HISTORY_SHARE_RATIO_LOG",
        params,
      });
    },
    editRewardRuleEndDateBatch({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/editRewardRuleEndDate_batch`,
        name: "EDIT_REWARD_RULE_END_DATE_BATCH",
        params,
      });
    },
    preInspectionRedpackageSpreadActivity({ commit }, params) {
      return post({
        commit,
        url: `/spread/redpackageSpreadActivity/preInspectionRedpackageSpreadActivity`,
        name: "PRE_INSPECTION_REDPACKAGE_SPREAD_ACTIVITY",
        params,
      });
    },
    storeActivityList({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/storeActivityList`,
        name: "STORE_ACTIVITY_LIST",
        params,
      });
    },
    cancelOrder({ commit }, params) {
      return post({
        commit,
        url: `/shop/order/cancel_order`,
        name: "CANCEL_ORDER",
        params,
      });
    },
    importRedpackageOutletRelByIdentifyCode({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/importRedpackageOutletRelByIdentifyCode`,
        name: "IMPORT_NOT_REL_SHOP",
        params,
      });
    },
    importShopCode({ commit }, params) {
      return post({
        commit,
        url: `/redpackageOutletRel/importStore`,
        name: "IMPORT_NOT_REL_SHOP",
        params,
      });
    },
    exportStoreActive({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/storeActivityListNew`,
        name: "EXPORT_STORE_ACTIVE",
        params,
      });
    },
    getcashQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/getcash/account/queryPageList`,
        name: "GETCASH_QUERY_PAGE_LIST",
        params,
      });
    },
    getcashGet({ commit }, params) {
      return post({
        commit,
        url: `/getcash/account/get`,
        name: "GETCASH_GET",
        params,
      });
    },
    getcashSave({ commit }, params) {
      return post({
        commit,
        url: `/getcash/account/save`,
        name: "GETCASH_SAVE",
        params,
      });
    },
    getcashUpdate({ commit }, params) {
      return post({
        commit,
        url: `/getcash/account/update`,
        name: "GETCASH_UPDATE",
        params,
      });
    },
    getcashQueryFlowerList({ commit }, params) {
      return post({
        commit,
        url: `/getcash/account/queryFlowerList`,
        name: "GETCASH_QUERY_FLOWER_LIST",
        params,
      });
    },
    getcashRuleQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/getcash/rule/queryPageList`,
        name: "GETCASH_RULE_QUERY_PAGE_LIST",
        params,
      });
    },
    getcashRuleGet({ commit }, params) {
      return post({
        commit,
        url: `/getcash/rule/get`,
        name: "GETCASH_RULE_GET",
        params,
      });
    },
    getcashRuleSave({ commit }, params) {
      return post({
        commit,
        url: `/getcash/rule/save`,
        name: "GETCASH_RULE_SAVE",
        params,
      });
    },
    getcashRuleUpdate({ commit }, params) {
      return post({
        commit,
        url: `/getcash/rule/update`,
        name: "GETCASH_RULE_UPDATE",
        params,
      });
    },
    thirdContractCompanyInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCompanyInfo/queryPageList`,
        name: "THIRD_CONTRACT_COMPANY_INFO_QUERY_PAGE_LIST",
        params,
      });
    },
    thirdContractCompanyInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCompanyInfo/add`,
        name: "THIRD_CONTRACT_COMPANY_INFO_ADD",
        params,
      });
    },
    thirdContractCompanyInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCompanyInfo/edit`,
        name: "THIRD_CONTRACT_COMPANY_INFO_EDIT",
        params,
      });
    },
    thirdContractCustomerInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerInfo/queryPageList`,
        name: "THIRD_CONTRACT_CUSTOMER_INFO_QUERY_PAGE_LIST",
        params,
      });
    },
    thirdContractCustomerSettlementRecordUploadWorkPlan({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/uploadWorkPlan`,
        name: "THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_UPLOAD_WORK_PLAN",
        params,
      });
    },
    thirdContractCustomerSettlementRecordZlbPublishOldTask({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/zlbPublishOldTask`,
        name: "THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_ZLB_PUBLISH_OLD_TASK",
        params,
      });
    },
    thirdContractCustomerSettlementRecordGzllePublishOldTask(
      { commit },
      params
    ) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/gzlleAddOrders`,
        name:
          "THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_GZLLE_PUBLISH_OLD_TASK",
        params,
      });
    },
    thirdContractCustomerSettlementRecordQueryWorkPlan({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/queryWorkPlan`,
        name: "THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_QUERY_WORK_PLAN",
        params,
      });
    },
    thirdContractCustomerSettlementRecordGetOldTaskInfo({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/getOldTaskInfo`,
        name: "THIRD_CONTRACT_CUSTOMER_SETTLEMENT_RECORD_GET_OLD_TASK_INFO",
        params,
      });
    },
    // 微信
    queryWechatBatchStatus({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/wechatBatchStatus`,
        name: "WECHAT_BATCH_STATUS",
        params,
      });
    },
    // 银行卡
    querySettlementRecord({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/querySettlementRecord`,
        name: "QUERY_SETTLEMENT_RECORD",
        params,
      });
    },
    queryLastGuiderWhiteList({ commit }, params) {
      return post({
        commit,
        url: `/log/sysOperateMemoLog/queryLastGuiderWhiteList`,
        name: "QUERY_LAST_GUIDER_WHITE_LIST",
        params,
      });
    },
    batchFindStoreBasicInfoList({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/batchFindStoreBasicInfoList`,
        name: "BATCH_FIND_STORE_BASIC_INFO_LIST",
        params,
      });
    },
    ThirdCompanyInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/contract/ThirdCompanyInfo/queryPageList`,
        name: "THIRD_COMPANY_INFO_QUERY_PAGE_LIST",
        params,
      });
    },
    importEditUser({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/importEditUser`,
        name: "IMPORT_EDIT_USER",
        params,
      });
    },
    batchImportEmployee({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/batchImportEmployee`,
        name: "BATCH_IMPORT_EMPLOYEE",
        params,
      });
    },
    addNewIdcardImgByCustomerId({ commit }, params) {
      return post({
        commit,
        url: `/back/customerRiskControl/addNewIdcardImgByCustomerId`,
        name: "ADD_NEW_IDCARD_IMG_BY_CUSTOMER_ID",
        params,
      });
    },
    doCheckCustomerIdentityElements({ commit }, params) {
      return post({
        commit,
        url: `/back/customerRiskControl/doCheckCustomerIdentityElements`,
        name: "DO_CHECK_CUSTOMER_IDENTITY_ELEMENTS",
        params,
      });
    },

    genSettlementRecord({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/genSettlementRecord`,
        name: "GEN_SETTLEMENT_RECORD",
        params,
      });
    },
    sendSetIpWhiteListSmsUniqueCode({ commit }, params) {
      return post({
        commit,
        url: `/message/hmMessage/sendSetIpWhiteListEmailUniqueCode`,
        name: "SEND_SET_IP_WHITE_LIST_SMS_UNIQUE_CODE",
        params,
      });
    },
    checkSetIpWhiteListSmsUniqueCode({ commit }, params) {
      return post({
        commit,
        url: `/message/hmMessage/checkSetIpWhiteListAddEmail`,
        name: "CHECK_SET_IP_WHITE_LIST_SMS_UNIQUE_CODE",
        params,
      });
    },
    operateLockGetcashSn({ commit }, params) {
      return post({
        commit,
        url: `/back/customerRiskControl/operateLockGetcashSn`,
        name: "OPERATE_LOCK_GETCASH_SN",
        params,
      });
    },
    queryCustomerInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryCustomerInfo`,
        name: "QUERY_CUSTOMER_INFO",
        params,
      });
    },
    queryCustomerArchiveInfoList({ commit }, params) {
      return post({
        commit,
        url: `/micro/customerIdentityInfo/queryCustomerArchiveInfoList`,
        name: "QUERY_CUSTOMER_ARCHIVE_INFO_LIST",
        params,
      });
    },
    queryCustomerArchiveInfoByDynamicsCondition({ commit }, params) {
      return post({
        commit,
        url: `/micro/customerIdentityInfo/queryCustomerArchiveInfoByDynamicsCondition`,
        name: "QUERY_CUSTOMER_ARCHIVE_INFO_BY_DYNAMICS_CONDITION",
        params,
      });
    },
    queryCollectQueryList({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/queryCollectQueryList`,
        name: "QUERY_COLLECT_QUERY_LIST",
        params,
      });
    },
    querySettlementCompanyList({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/querySettlementCompanyList`,
        name: "QUERY_SETTLEMENT_COMPANY_LIST",
        params,
      });
    },
    queryCustomerBankList({ commit }, params) {
      return post({
        commit,
        url: `/contract/thirdContractCustomerSettlementRecord/queryCustomerBankList`,
        name: "QUERY_CUSTOMER_BANK_LIST",
        params,
      });
    },
    queryNumInfo({ commit }, params) {
      return post({
        commit,
        url: `/supplier/guider/declare/num_info`,
        name: "QUERY_NUM_INFO",
        params,
      });
    },
    batchIncreaseAutoOfflineDaysLimt({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/batchIncreaseAutoOfflineDaysLimt`,
        name: "BATCH_INCREASE_AUTO_OFFLINE_DAYS_LIMT",
        params,
      });
    },

    // 2024-6-3新增
    supplierWorkConfigqueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/queryPageList`,
        name: "SUPPLIER_WORK_CONFIG_QUERY_PAGE_LIST",
        params,
      });
    },
    supplierWorkConfigrefreshWorkConfig({ commit }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/refreshWorkConfig`,
        name: "SUPPLIER_WORK_CONFIG_REFRESH_WORK_CONFIG",
        params,
      });
    },
    supplierWorkConfigremoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/removeByModel`,
        name: "WORK_SUPPLIER_WORK_CONFIG_REMOVE_BYMODEL",
        params,
      });
    },
    storeBasicInfofindAuthSupplierBasicListl({ commit }, params) {
      return post({
        commit,
        url: `/storeBasicInfo/findAuthSupplierBasicList`,
        name: "STORE_BASIC_INFO_FIND_AUTH_SUPPLIE_RBASICLIST",
        params,
      });
    },
    // 2024-6-4新增
    exportguiderDeclareOperatelist({ commit }, params) {
      return post({
        commit,
        url: `/redpackage/manager/export/guider_declare/operate_list`,
        name: "MANAGER_EXPORT_GUIDER_DECLARE_OPERATE_LIST",
        params,
      });
    },
    // 2024-6-5新增
    refreshWorkConfigBySupplier({ commit }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/refreshWorkConfigBySupplier`,
        name: "SUPPLIER_WORK_CONFIG_REFRESH_WORK_CONFIG_BY_SUPPLIER",
        params,
      });
    },
    activityDetails({ commit }, params) {
      return post({
        commit,
        url: `/promotion/store/subscribeApply/querySubscribeApplyList`,
        name: "STORE_SUBSCRIBEAPPLY_QUERY_SUBSCRIBE_APPLYLIST",
        params,
      });
    },
    exportCustomReport({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/exportCustomReport`,
        name: "STORE_SSRBASIC_CONFIG_EXPORT_CUSTOM_REPORT",
        params,
      });
    },
    // 2024-6-11新增
    obtainDeclareGoodsDetailsEs({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierGoodsDetailsReport/obtainDeclareGoodsDetailsEs`,
        name: "SUPPLIER_GOODS_DETAILS_REPORT_OBTAIN_DECLARE_GOODS_DETAILS_ES",
        params,
      });
    },
    // 自定义报表接口 2024-6-14
    // 商品明细
    obtainDeclareGoodsEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierGoodsReport/obtainDeclareGoodsEs`,
        name: "OBTAIN_DECLARE_GOODS_ES",
        params,
      });
    },
    // 申报明细
    obtainDeclareBillEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierDeclareRowsReport/obtainDeclareBillRowsEsPage`,
        name: "OBTAIN_DECLARE_BILL_ES",
        params,
      });
    },
    // 门店统计
    obtainShopEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierShopRowsAggsReport/obtainShopRowsAggsEsPage`,
        name: "OBTAIN_SHOP_ES",
        params,
      });
    },
    // 导购统计
    obtainGuiderEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierGuiderRowsAggsReport/obtainGuiderRowsAggsEsPage`,
        name: "OBTAIN_GUIDER_ES",
        params,
      });
    },
    // 分成明细
    obtainShareEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierShareReport/obtainShareEs`,
        name: "OBTAIN_SHARE_ES",
        params,
      });
    },
    // 品牌明细
    obtainBrandEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierBrandRowsReport/obtainRewardRowsEsPage`,
        name: "OBTAIN_BRAND_ES",
        params,
      });
    },
    // 品牌明细新
    obtainBrandDetailsEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierBrandDetailsRowsReport/obtainBrandDetailsRowsEsPage`,
        name: "OBTAIN_BRAND_DETAILS_ES",
        params,
      });
    },
    // 退款明细
    obtainRefundEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierRefundReport/obtainRefundEs`,
        name: "OBTAIN_REFUND_ES",
        params,
      });
    },
    // 商户报表查询(新增)
    // 商品明细
    obtainStoreGoodsEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeGoodsReport/obtainDeclareGoodsEs`,
        name: "OBTAIN_STORE_DECLARE_GOODS_ES",
        params,
      });
    },
    // 申报明细
    obtainStoreBillEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeDeclareBillReport/obtainDeclareBillEs`,
        name: "OBTAIN_STORE_DECLARE_BILL_ES",
        params,
      });
    },
    // 门店统计
    obtainStoreShopEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeShopReport/obtainShopEs`,
        name: "OBTAIN_STORE_SHOP_ES",
        params,
      });
    },
    // 导购统计
    obtainStoreGuiderEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeGuiderReport/obtainGuiderEs`,
        name: "OBTAIN_STORE_GUIDER_ES",
        params,
      });
    },
    // 分成明细
    obtainStoreShareEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeShareReport/obtainShareEs`,
        name: "OBTAIN_STORE_STORE_SHARE_ES",
        params,
      });
    },
    // 品牌明细
    obtainStoreBrandEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeBrandReport/obtainBrandEs`,
        name: "OBTAIN_STORE_BRAND_ES",
        params,
      });
    },
    // 退款明细
    obtainStoreRefundEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeRefundReport/obtainRefundEs`,
        name: "OBTAIN_STORE_REFUND_ES",
        params,
      });
    },
     // 商品退款明细
     obtainGoodsRefundEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierRefundGoodsDetailsReport/obtainRefundEs`,
        name: "OBTAIN_GOODS_REFUND_ES",
        params,
      });
    },
    // 获取自定义报表配置数据
    querySsrBasicConfig({ commit }, params) {
      return post({
        commit,
        url: `/store/ssrBasicConfig/querySsrBasicConfig`,
        name: "QUERY_SSR_BASIC_CONFIG",
        params,
      });
    },
    // 商品明细导出
    exportDeclareGoodsEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierGoodsReport/exportDeclareGoodsEs`,
        name: "EXPORT_DECLARE_GOODS_ES",
        params,
      });
    },
    // 申报明细导出
    exportDeclareBillEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierDeclareRowsReport/exportDeclareBillRowsEs`,
        name: "EXPORT_DECLARE_BILL_ES",
        params,
      });
    },
    // 门店统计导出
    exportShopEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierShopRowsAggsReport/exportShopRowsAggsEs`,
        name: "EXPORT_SHOP_ES",
        params,
      });
    },
    // 导购统计导出
    exportGuiderEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierGuiderRowsAggsReport/exportGuiderRowsAggsEs`,
        name: "EXPORT_GUIDER_ES",
        params,
      });
    },
    // 品牌明细导出
    exportBrandEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierBrandRowsReport/exportRewardRowsEs`,
        name: "EXPORT_BRAND_ES",
        params,
      });
    },
    // 品牌明细导出新
    exportBrandDetailsEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierBrandDetailsRowsReport/exportBrandDetailsRowsEs`,
        name: "EXPORT_BRAND_DETAILS_ES",
        params,
      });
    },
    // 分成明细导出
    exportShareEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierShareReport/exportShareEs`,
        name: "EXPORT_SHARE_ES",
        params,
      });
    },
    // 退款明细导出
    exportRefundEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierRefundReport/exportRefundEs`,
        name: "EXPORT_REFUND_ES",
        params,
      });
    },
    // 商品退款明细导出
    exportGoodsRefundEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierRefundGoodsDetailsReport/exportRefundEs`,
        name: "EXPORT_GOODS_REFUND_ES",
        params,
      });
    },
    // 商户自定义报表导出
    // 商品明细导出
    exportStoreGoodsEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeGoodsReport/exportDeclareGoodsEs`,
        name: "EXPORT_STORE_DECLARE_GOODS_ES",
        params,
      });
    },
    // 申报明细导出
    exportStoreBillEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeDeclareBillReport/exportDeclareBillEs`,
        name: "EXPORT_STORE_DECLARE_BILL_ES",
        params,
      });
    },
    // 门店统计导出
    exportStoreShopEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeShopReport/exportShopEs`,
        name: "EXPORT_STORE_SHOP_ES",
        params,
      });
    },
    // 导购统计导出
    exportStoreGuiderEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeGuiderReport/exportGuiderEs`,
        name: "EXPORT_STORE_GUIDER_ES",
        params,
      });
    },
    // 品牌明细导出
    exportStoreBrandEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeBrandReport/exportBrandEs`,
        name: "EXPORT_STORE_BRAND_ES",
        params,
      });
    },
    // 分成明细导出
    exportStoreShareEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeShareReport/exportShareEs`,
        name: "EXPORT_STORE_SHARE_ES",
        params,
      });
    },
    // 退款明细导出
    exportStoreRefundEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/storeRefundReport/exportRefundEs`,
        name: "EXPORT_STORE_REFUND_ES",
        params,
      });
    },
    // 组合报表导出
    exportCompositeEs({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierCompositeReport/exportCompositeEs`,
        name: "EXPORT_COMPOSITE_ES",
        params,
      });
    },
    // 驳回列表
    queryRejectPageList({ commit }, params) {
      return post({
        commit,
        url: `/notice/redpackageRejectReason/queryPageList`,
        name: "QUERY_PAGE_LIST",
        params,
      });
    },
    // 获取分类名
    getListByConfigClass({ commit }, params) {
      return post({
        commit,
        url: `/storepermissions/storeSystemParamInfo/getListByConfigClass`,
        name: "GET_LIST_BY_CONFIG_CLASS",
        params,
      });
    },

    addOrUpdateRedpackageRejectReason({ commit }, params) {
      return post({
        commit,
        url: `/notice/redpackageRejectReason/addOrUpdateRedpackageRejectReason`,
        name: "ADD_OR_UPDATE_REDPACKAGE_REJECT_REASON",
        params,
      });
    },

    delRedpackageRejectReason({ commit }, params) {
      return post({
        commit,
        url: `/notice/redpackageRejectReason/delRedpackageRejectReason`,
        name: "DEL_REDPACKAGE_REJECT_REASON",
        params,
      });
    },

    saveRedpackageBadgeInfo({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeInfo/saveRedpackageBadgeInfo`,
        name: "SAVE_REDPACKAGE_BADGE_INFO",
        params,
      });
    },
    // 获取勋章列表
    queryRedpackageBadgeInfoPage({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeInfo/queryRedpackageBadgeInfoPage`,
        name: "QUERY_REDPACKAGE_BADGE_INFO_PAGE",
        params,
      });
    },
    queryRedpackageBadgeInfoById({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeInfo/queryRedpackageBadgeInfoById`,
        name: "QUERY_REDPACKAGE_BADGE_INFO_BY_ID",
        params,
      });
    },

    editRedpackageBadgeInfo({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeInfo/editRedpackageBadgeInfo`,
        name: "EDIT_REDPACKAGE_BADGE_INFO",
        params,
      });
    },

    editRedpackageBadgeInfoPublishState({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeInfo/updateRedpBadgeInfoPublishState`,
        name: "EDIT_REDPACKAGE_BADGE_INFO_PUBLISH_STATE”",
        params,
      });
    },
    // 查询权益列表
    queryBenefitUseRecordPage({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeCollectionRecord/queryBenefitUseRecordPage`,
        name: "QUERY_BENEFIT_USE_RECORD_PAGE",
        params,
      });
    },
    // 权益明细
    queryBenefitUseRecordGroup({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeBenefitUseRecord/queryBenefitUseRecordGroup`,
        name: "QUERY_BENEFIT_USE_RECORD_GROUP",
        params,
      });
    },

    // 明细导出
    exportGuiderBenefitUseRecord({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeCollectionRecord/exportGuiderBenefitUseRecord`,
        name: "EXPORT_GUIDER_BENEFIT_USE_RECORD",
        params,
      });
    },

    // 上线 发送验证码
    redpackageBadgeSendOnlineMailMedal({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeInfo/redpackageBadgeSendOnlineMail`,
        name: "REDPACKAGE_BADGE_SEND_ONLINE_MAIL_MEDAL",
        params,
      });
    },

    // 上线确定验证码
    updateRedpBadgeInfoPublishStateMedal({ commit }, params) {
      return post({
        commit,
        url: `/badge/redpackageBadgeInfo/updateRedpBadgeInfoPublishState`,
        name: "UPDATE_REDPACKAGE_BADGE_INFO_PUBLISH_STATE_MEDAL",
        params,
      });
    },
    // 供货商新建活动商品导入
    rewardGoodsImportEs({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/rewardGoodsImportEs`,
        name: "REWARD_GOODS_IMPORTES",
        params,
      });
    },
    // 供货商新建活动商品引入
    queryRewardGoodsEsPageList({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/queryRewardGoodsEsPageList`,
        name: "QUERY_REWARD_GOODS_ESPAGELIST",
        params,
      });
    },
    // 
    saveSupplierRewardRuleInfoImportGoodsEs({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/saveSupplierRewardRuleInfoImportGoodsEs`,
        name: "SAVE_SUPPLIER_REWARD_RULEIN_FOIMPORT_GOODSES",
        params,
      });
    },

    verifyRewardRuleName({ commit }, params) {
      return post({
        commit,
        url: `/supplierRewardRuleInfo/verifyRewardRuleName`,
        name: "VERIFY_REWARF_RULENAME",
        params,
      });
    },
    //供应商设置配置-是否运行导购自动加入品牌接口
    supplierSetConfig({ commit }, params) {
      return post({
        commit,
        url: `/config/supplierGuiderConfig/supplierSetConfig`,
        name: "SUPPLIER_SET_CONFIG",
        params,
      });
    },
     //供应商设置配置-导购查询供货商品牌
     guiderViewSupplierBrand({ commit }, params) {
      return post({
        commit,
        url: `/config/supplierGuiderConfig/guiderViewSupplierBrand`,
        name: "GUIDER_VIEW_WUPPLIER_BRAND",
        params,
      });
    },
     //供应商设置配置-保存导购供货商品牌
     hemiaoSetGuiderConfig({ commit }, params) {
      return post({
        commit,
        url: `/config/supplierGuiderConfig/hemiaoSetGuiderConfig`,
        name: "HEMIAO_SET_GUIDER_CONFIG",
        params,
      });
    },
    //系统分词
    getGoodsKeyWordList({ commit }, params) {
      return post({
        commit,
        url: `/supplierGoodsInfo/getGoodsKeyWordList`,
        name: "GET_GOODS_KEY_WORD_LIST",
        params,
      });
    },
     //月结导出
     exportAllowAutoBrandList({ commit }, params) {
      return post({
        commit,
        url: `/manager/report/micro/supplierGuiderConfigReport/exportAllowAutoBrandList`,
        name: "EXPORT_ALLOW_AUTO_BRAND_LIST",
        params,
      });
    },
  },
};

export default guiderCommission;
